import React from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import useTranslation from "../../customHooks/translations";
import Grid from "@mui/material/Grid";
import {DEFAULT_THEME_COLOR, DEFAULT_GRADIENT} from "../../constants/theme";

const FreakListComponent = (props) => {
  const navigate = useNavigate();
  const translation = useTranslation();

  const calculateStyles = idx => ({
    cursor: 'pointer',
    borderRadius: 2,
    mb: 0.5,
    '&:hover': {
      background: 'linear-gradient(135deg, rgba(54,201,162,0.12) 0%, rgba(79,172,254,0.12) 100%)',
    },
  });
  
  const getPlaceIcon = idx => {
    if (idx === 0) {
       return '🏆';
    }
    if (idx === 1) {
      return '🥈'
    }
    if (idx === 2) {
      return '🥉';
    }
  };

  return (
    <>
      <List sx={{ width: '100%', maxWidth: '100%', bgcolor: 'transparent' }}>
        {
          (props.data || []).map((item, idx) => (
            <>
              <ListItem
                alignItems="flex-start"
                onClick={() => navigate(`/@${item.username}`)}
                sx={calculateStyles(idx)}
              >
                <Typography
                  variant={idx <= 9 ? 'h5' : 'h7'}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minWidth: 40,
                    marginTop: 1.5,
                    color: 'grey',
                    marginRight: 2,
                  }}>
                  {getPlaceIcon(idx)}
                </Typography>
                <ListItemAvatar>
                  <Avatar alt={item.id} src={item.imageUrl || './icon-48x48.png'} />
                </ListItemAvatar>
                <Grid container>
                  <Grid container xs={12} sx={{ marginTop: 1, }}>
                    <React.Fragment>
                      {idx+1}. {item.username}
                      <Avatar
                        alt={item.id}
                        sx={{
                          width: 14,
                          height: 14,
                          marginLeft: 2,
                          marginRight: 0.5,
                          marginTop: 0.5,
                        }}
                        src={'./icon-48x48.png'}
                      />
                      {item.points}F
                    </React.Fragment>
                  </Grid>
                  <Grid container xs={12}>
                    <React.Fragment>
                      <span style={{
                        color: 'grey',
                        fontSize: 12,
                      }}>
                        {`@${item.username}`}
                      </span>
                    </React.Fragment>
                  </Grid>
                </Grid>

              </ListItem>
              <Divider variant="inset" component="li" />
            </>
          ))
        }
      </List>
    </>
  )
};

export default FreakListComponent;
